import {
    Directive,
    ElementRef,
    Input,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { UserService } from '../services/user.service';
import { PermissionService } from '../services/permission.service';

@Directive({
    selector: '[hasPermission]',
    standalone: true,
})
export class PermissionDirective implements OnInit {
    private permissions = [];

    constructor(
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userService: UserService,
        private permissionService: PermissionService
    ) {}

    ngOnInit() {
        this.updateView();
    }

    @Input()
    set hasPermission(val: string[]) {
        this.permissions = val;
        this.updateView();
    }

    private updateView() {
        const show = this.checkPermission();
        this.viewContainer.clear();
        if (show) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private checkPermission() {
        if (!this.userService.getUser()) {
            return false;
        }

        if (!this.permissions) {
            return true;
        }

        if (this.permissionService.hasPermissions(this.permissions)) {
            return true;
        }

        return false;
    }
}
